import React from 'react';
import { toast } from 'react-toastify';

const DeleteConfirmModal = ({deleteReview, refetch, setDeleteReview}) => {
    const {name, email} = deleteReview;
    const handleDelete = () => {
        fetch(`https://limitless-hollows-00488.herokuapp.com/review/${email}`, {
            method: 'DELETE',
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.deletedCount) {
                    toast.success(`Doctor: ${name} is deleted.`)
                    setDeleteReview(null);
                    refetch();
                }
            })
    }
    return (
        <div>
            <input type="checkbox" id="delete-confirm-modal" className="modal-toggle" />
            <div className="modal modal-bottom sm:modal-middle">
                <div className="modal-box">
                    <h3 className="font-bold text-lg text-rose-400">Are you sure you want to delete {name}!</h3>
                    
                    <div className="modal-action">
                    <button onClick={() => handleDelete()} className="btn btn-xs btn-error">Delete</button>
                        <label htmlFor="delete-confirm-modal" className="btn btn-xs">Cancel</label>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default DeleteConfirmModal;